import { render, staticRenderFns } from "./MetadataForm.vue?vue&type=template&id=5bf445f4"
import script from "./MetadataForm.vue?vue&type=script&lang=js"
export * from "./MetadataForm.vue?vue&type=script&lang=js"
import style0 from "./MetadataForm.vue?vue&type=style&index=0&id=5bf445f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports